import { Link } from "react-router-dom";
import type { ListingTemplateMeta } from "@/lib/listing-templates";
import { templateChannelLabel } from "@/lib/listing-templates";
import TemplateThumbnail from "./TemplateThumbnail";

export default function TemplateCard({
  template,
  onUse,
}: {
  template: ListingTemplateMeta;
  onUse?: () => void;
}) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden flex flex-col group hover:border-slate-300 transition-colors">
      {/* Thumbnail */}
      <div className="aspect-[16/10] border-b border-slate-100 bg-slate-50 overflow-hidden">
        <TemplateThumbnail templateId={template.id} />
      </div>

      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center justify-between gap-2">
          <h3 className="text-base font-semibold text-slate-900">{template.name}</h3>
          <span className="shrink-0 inline-flex items-center gap-1 text-xs font-medium text-slate-500 bg-slate-50 border border-slate-200 rounded-full px-2.5 py-1">
            <i className="ri-store-2-line" />
            {templateChannelLabel(template.channels)}
          </span>
        </div>
        <p className="text-sm text-slate-500 mt-1">{template.tagline}</p>

        <div className="flex flex-wrap gap-1.5 mt-3">
          {template.suitability.map((tag) => (
            <span key={tag} className="text-xs text-slate-500 bg-slate-50 rounded-full px-2 py-0.5">
              {tag}
            </span>
          ))}
        </div>

        <p className="text-sm text-slate-600 leading-relaxed mt-3 flex-1">{template.description}</p>

        <div className="flex items-center gap-2 mt-5">
          <Link
            to={`/listing-templates/preview/${template.id}`}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 whitespace-nowrap"
          >
            <i className="ri-eye-line" /> Preview
          </Link>
          <button
            onClick={onUse}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 rounded-lg whitespace-nowrap"
          >
            Use template
          </button>
        </div>
      </div>
    </div>
  );
}